export default __webpack_public_path__ + "static/media/Adamakis.bb6297f3.png";